<div class=" cc-payment_sum_wrapper ">
    <fieldset class="cc-payment-scheduler-border">
        <legend class="cc-payment-report-scheduler-border">CC Payment Report Search Criteria</legend>
        <div class="col-md-12">
            <form #form="ngForm" (ngSubmit)="getSearch(1)" autocomplete="off">
                <div class="row">

                    <div class="col-sm-2 cc-payment_sum_col">
                        <div class="form-group has-feedback ">
                            <label for="dateFrom" class="control-label">Date From:</label>

                            <div class="cc-payment-input-group">
                                <input class="form-control" id="dateFrom" name="dateFrom" [(ngModel)]="DateFrom" [maxDate]="DateTo" ngbDatepicker #dateFrom="ngbDatepicker" style="cursor: pointer;" (click)="dateFrom.toggle()" readonly required>
                                <i (click)="dateFrom.toggle()" class="fa fa-calendar" aria-hidden="true"></i>

                                <!-- <button class="btn btn-outline-secondary calendar" (click)="dateFrom.toggle()"
                                    type="button"></button> -->
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-2 cc-payment_sum_col ">
                        <div class="form-group has-feedback">
                            <label for="DateTo" class="control-label">Date To:</label>

                            <div class="cc-payment-input-group">
                                <input class="form-control" id="DateTo" name="DateTo" [(ngModel)]="DateTo" ngbDatepicker [maxDate]="maxDate" [minDate]="DateFrom" #dateTo="ngbDatepicker" style="cursor: pointer;" (click)="dateTo.toggle()" readonly required>
                                <i (click)="dateTo.toggle()" class="fa fa-calendar " aria-hidden="true"></i>

                                <!-- <button class="btn btn-outline-secondary calendar" (click)="dateTo.toggle()"
                                    type="button"></button> -->
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-2 cc-payment_sum_col">
                        <div class="form-group">
                            <label class="control-label">Franchise:</label>
                            <select class="form-control" *ngIf="customer" [(ngModel)]="ccPaymentReportSearchCriteria.FranchiseId" name="FranchiseId" required>
                                <option value="">--- Please select ---</option>
                                <option *ngFor="let ccPaymentReportStatus of customer.FranchiseList"
                                    [value]="ccPaymentReportStatus.Value">{{ccPaymentReportStatus.Text}}</option>

                            </select>
                        </div>
                    </div>

                    <div class="col-sm-3 cc-payment_sum_col">
                        <p class="cc-payment-redfields" *ngIf="!form.valid">* All fields are required</p>
                    </div>



                    <div class="col-sm-3 cc-payment_sum_col">
                        <div class="form-group orders_sum_top cc-payment_sum_top">
                            <div class="pull-right">
                                <button type="submit" class="btn btn-primary" [disabled]="!form.valid" (click)="getSearch(1)">Search</button>
                                <button type="button" class="btn btn-default" (click)="cancelSearch()">Clear</button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    </fieldset>

    <fieldset class="cc-payment-scheduler-border clearfix marign_10">
        <legend class="cc-payment-report-scheduler-border">Customers List</legend>
        <div *ngIf="customer">
            <div *ngIf="!customerSearch?.PaginatedResult?.TotalRecords > 0">
                <h6 class="cc-payment-timespan">Total Amount for this Timespan = $0.00</h6>
            </div>
            <div *ngIf="customerSearch?.PaginatedResult?.TotalRecords > 0">
                <h6 class="cc-payment-timespan">Total Amount for this Timespan = ${{customerSearch.SumAmount}}</h6>
            </div>

        </div>


        <div class="cc-payment-panel_tablepayment">
            <div class="panel panel-default ">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>

                                <th>Acc. #</th>
                                <th>Customer Name</th>
                                <th>Total Amount</th>
                                <th>Card Holder Name</th>
                                <th>Card Mask</th>
                                <th>Expiry Date</th>
                                <th>Card Type</th>
                                <th>Insert Date</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="customerSearch">
                            <tr *ngFor="let ccPaymentReportSearch of customerSearch.CustomerWiseInvoicesSummaryList">
                                <td>{{ccPaymentReportSearch.AccountNo}}</td>
                                <td>{{ccPaymentReportSearch.CustomerName}}</td>
                                <td style="text-align: right;">${{ccPaymentReportSearch.TotalAmount}}</td>
                                <td>{{ccPaymentReportSearch.CardHolderName}}</td>
                                <td>{{ccPaymentReportSearch.CardMask}}</td>
                                <td>EXP-{{ccPaymentReportSearch.ExpiryDate | slice:0:2}}/{{ccPaymentReportSearch.ExpiryDate | slice:2:4}}</td>
                                <td>{{ccPaymentReportSearch.CardType}}</td>
                                <td>{{ccPaymentReportSearch.InsertDate | date: 'MM/dd/yyyy'}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class=" paraNoRec">
                        <p *ngIf="paraNoRec == true">No Record Found</p>
                    </div>

                    <div *ngIf="customerSearch?.PaginatedResult?.TotalRecords > 10" style="float: right;">
                        <ngb-pagination [(page)]="page" [maxSize]="10" [collectionSize]="customerSearch?.PaginatedResult?.TotalRecords" [ellipses]="true" [boundaryLinks]="true" (pageChange)="getSearch($event)"></ngb-pagination>

                    </div>
                </div>



            </div>
        </div>
    </fieldset>

</div>